import { Modelo } from '@ext/index';
import * as Types from './Provincia.types';
import moment ,{ Moment } from 'moment';

export class IProvincia extends Modelo {

    public constructor( Json: any = null ) {
        super( Json );
        if ( Json )
            this.set();
    }

    public Id : number = 0;
public Nombre : string = '';
public Codigo : string = '';


    public getJson(): any {
        let json: any = {};

        json.id = this.Id;
json.nombre = this.Nombre;
json.codigo = this.Codigo;


        return json;
    }


    public set(): boolean {

        this.Id = !this.Json.id ? 0 : this.Json.id;
this.Nombre = !this.Json.nombre ? '' : this.Json.nombre;
this.Codigo = !this.Json.codigo ? '' : this.Json.codigo;


        this.Existe = true;
        return this.Existe;
    }

    public get Vista(): Vista {
        return new Vista( this );
    }
}

class Vista {
    constructor( Model: IProvincia ) {
        this.Model = Model;
    }

    public Model: IProvincia;
}